import moment from 'moment-timezone'

function verificaData (data, format) {
  if (typeof format !== 'string') {
    format = 'DD/MM/YYY'
  }
  return (moment(data, format)).isValid()
}

/**
 * Valida uma data-hora e a converte para objeto moment
 * @param {string} data_hora Data a ser validada
 * @param {string} format Formato da data a ser validada
 * @returns moment
 */
function getValidMoment(data_hora, format, timezone) {
  if(verificaData(data_hora, format) === true){
    return moment.tz(data_hora, format, timezone)
  } else {
    return null
  }
}

/**
 * Valida uma data-hora com timezone UTC +00:00 e a converte para objeto moment
 * @param {string} data_hora Data a ser validada
 * @param {string} format Formato da data a ser validada
 * @returns moment
 */
function getValidMomentUTC(data_hora, format) {
  if(verificaData(data_hora, format) === true){
    return moment.tz(data_hora, format)
  } else {
    return null
  }
}

/**
 * Converte uma data do formato Americano para o Brasileiro
 * @param {string} data Data em formato US
 * @returns string
 */
function converteData(data){
  var objMoment = getValidMoment(data, 'YYYY-MM-DD')
  if (objMoment !== null){
    return objMoment.format('DD/MM/YYYY')
  } else {
    return '00/00/000'
  }
}

/**
 * Converte uma data-hora do formato Americano para o Brasileiro com timezone de Recife
 * @param {string} data_hora Data-hora em formato US
 * @returns string
 */
function converteDataHora(data_hora) {
  var objMoment = getValidMoment(data_hora, 'YYYY-MM-DD HH:mm:ss').utc().tz('America/Recife')
  if (objMoment !== null){
    return `${objMoment.format('DD/MM/YYYY')} às ${objMoment.format('HH:mm:ss')}`
  } else {
    return '00/00/000 às 00:00:00'
  }
}

/**
 * Converte uma data do formato Brasileiro para o Americano
 * @param {string} data Data em formato BR
 * @returns string
 */
function formataData(data) {
  var objMoment = getValidMoment(data, 'DD/MM/YYYY')
  if (objMoment !== null){
    return objMoment.format('YYYY-MM-DD')
  } else {
    return '00/00/000'
  }
}

/**
 * Converte uma data-hora do formato Brasileiro com timezone de Recife para o Americano com timezone UTC +00:00
 * @param {string} data_hora Data-hora em formato BR
 * @returns string
 */
function formataDataHora(data_hora) {
  var objMoment = getValidMoment(data_hora, 'DD/MM/YYYY HH:mm:ss', 'America/Recife').utc()
  if (objMoment !== null){
    return objMoment.format('YYYY-MM-DD HH:mm:ss')
  } else {
    return '0000-00-00 00:00:00'
  }
}

function formataCPF (cpf) {
  if (cpf !== null){
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4')
  }
}

function formataCNPJ (cnpj) {
  if (cnpj !== null) {
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5')
  }
}

/* eslint-disable no-redeclare */
function floatParaMoeda (n, c, d, t) {
  var c = isNaN(c = Math.abs(c)) ? 2 : c
  var d = d === undefined ? ',' : d
  var t = t === undefined ? '.' : t
  var s = n < 0 ? '-' : ''
  var i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + ''
  var j = (j = i.length) > 3 ? j % 3 : 0
  return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '')
}

function moedaParaFloat (valor) {
  return isNaN(valor) === false ? parseFloat(valor) : parseFloat(valor.replace('R$', '').replace('.', '').replace(',', '.'))
}

function validaCPF (cpfInput) {
  var Soma
  var Resto
  var i
  Soma = 0
  cpfInput = (cpfInput ? cpfInput.replace(/\D/g, '') : cpfInput)

  if (cpfInput === null || cpfInput === '000.000.000-00' || cpfInput === '00000000000') {
    return false
  }

  for (i = 1; i <= 9; i++) {
    Soma = Soma + parseInt(cpfInput.substring(i - 1, i)) * (11 - i)
  }

  Resto = (Soma * 10) % 11

  if ((Resto === 10) || (Resto === 11)) {
    Resto = 0
  }
  if (Resto !== parseInt(cpfInput.substring(9, 10))) {
    return false
  }

  Soma = 0

  for (i = 1; i <= 10; i++) {
    Soma = Soma + parseInt(cpfInput.substring(i - 1, i)) * (12 - i)
  }

  Resto = (Soma * 10) % 11

  if ((Resto === 10) || (Resto === 11)) {
    Resto = 0
  }
  if (Resto !== parseInt(cpfInput.substring(10, 11))) {
    return false
  } else {
    return true
  }
}

function validarCNPJ(cnpj) {
 
  cnpj = cnpj.replace(/[^\d]+/g,'');

  if(cnpj == '') return false;
   
  if (cnpj.length != 14)
      return false;

  // Elimina CNPJs invalidos conhecidos
  if (cnpj == "00000000000000" || 
      cnpj == "11111111111111" || 
      cnpj == "22222222222222" || 
      cnpj == "33333333333333" || 
      cnpj == "44444444444444" || 
      cnpj == "55555555555555" || 
      cnpj == "66666666666666" || 
      cnpj == "77777777777777" || 
      cnpj == "88888888888888" || 
      cnpj == "99999999999999")
      return false;
       
  // Valida DVs
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0,tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
          pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(0))
      return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0,tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
          pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(1))
        return false;

  return true;
}

function converteTimestamp (timestamp) {
  if (timestamp !== '') {
    return (moment.unix(timestamp)).format('DD/MM/YYYY HH:mm:ss')
  }
}

function unformat (input, precision) {
  var negative = input.indexOf('-') >= 0 ? -1 : 1
  var numbers = onlyNumbers(input)
  var currency = numbersToCurrency(numbers, precision)
  return parseFloat(currency) * negative
}

function onlyNumbers (input) {
  return toStr(input).replace(/\D+/g, '') || '0'
}

// Uncaught RangeError: toFixed() digits argument must be between 0 and 20 at Number.toFixed
function fixed (precision) {
  return between(0, precision, 20)
}

function between (min, n, max) {
  return Math.max(min, Math.min(n, max))
}

function numbersToCurrency (numbers, precision) {
  var exp = Math.pow(10, precision)
  var float = parseFloat(numbers) / exp
  return float.toFixed(fixed(precision))
}

function toStr (value) {
  return value ? value.toString() : ''
}

/**
 * Compara a diferença de tempo entre duas datas/hora e retorna um objeto
 * @param {string|object} data_inicio Data-hora em formato universal
 * @param {string|object} data_fim Data-hora em formato universal
 * @returns {object|null}
 */
 function dateDiff(data_inicio, data_fim, format) {
  if (typeof format === 'undefined'){
    format = 'YYYY-MM-DD'
  }
  if (typeof data_inicio === 'string') {
    data_inicio = getValidMoment(data_inicio, format)
  }

  if (typeof data_inicio === 'string') {
    data_fim = getValidMoment(data_fim, format)
  }

  let diff = moment.duration(data_fim.diff(data_inicio));

  if (diff.isValid() === true){
    return {
      'days': diff.get('days'),
      'hours': diff.get('hours'),
      'milliseconds': diff.get('milliseconds'),
      'minutes': diff.get('minutes'),
      'months': diff.get('months'),
      'seconds': diff.get('seconds'),
      'years': diff.get('years'),
    }
  } else {
    return null
  }
}

function converteIdade(nascimento, format = "YYYY-MM-DD"){
  return dateDiff(nascimento, moment(), format)['years']
}

function countDias(data_inicio, data_fim, format = 'YYYY-MM-DD'){
  let inicio = getValidMoment(data_inicio, format)
  let fim = getValidMoment(data_fim, format)
  let dias  = 0
  if(inicio && fim){
    dias = fim.diff(inicio, 'days')
  }
  return dias
}

export {verificaData}
export {getValidMoment}
export {formataCPF}
export {formataCNPJ}
export {validarCNPJ}
export {floatParaMoeda}
export {moedaParaFloat}
export {converteData}
export {converteDataHora}
export {formataData}
export {formataDataHora}
export {validaCPF}
export {converteTimestamp}
export {unformat}
export {countDias}
export {converteIdade}



// WEBPACK FOOTER //
// ./src/assets/js/form-utils.js